import { Link } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcLoading, ProcPagination } from "../../components/ProcurementLayout";
import { ProcStatusBadge } from "../../components/ProcStatusBadge";
import { useAsyncData, usePageState } from "../../hooks";

export default function RiskListPage() {
  const { page, size, setPage, state } = usePageState();

  const { data, loading, error } = useAsyncData(
    () => adminProcApi.listRisks({ page: state.page, size: state.size }),
    [state.page, state.size],
  );

  function likelihoodColor(v: string) {
    if (v === "HIGH") return "text-red-600 font-bold";
    if (v === "MEDIUM") return "text-amber-600 font-bold";
    return "text-emerald-600 font-bold";
  }

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Procurement Risk Register</h1>
        </div>
        <Link to="/procurement/admin/risks/new" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">
          New Risk
        </Link>
      </div>

      {loading && <ProcLoading />}
      {error && <ProcError message={error} />}

      {!loading && !error && data && (
        <>
          <div className="rounded-2xl border bg-white shadow-sm overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Serial No</th>
                  <th className="px-4 py-3">Risk Identified</th>
                  <th className="px-4 py-3">Likelihood</th>
                  <th className="px-4 py-3">Impact</th>
                  <th className="px-4 py-3">Responsible Officer</th>
                  <th className="px-4 py-3">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.content.length === 0 && (
                  <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No risks found.</td></tr>
                )}
                {data.content.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono font-semibold text-slate-900">{r.serialNo}</td>
                    <td className="px-4 py-3 text-slate-700 max-w-xs truncate">{r.riskIdentified}</td>
                    <td className={`px-4 py-3 ${likelihoodColor(r.likelihood)}`}>{r.likelihood}</td>
                    <td className={`px-4 py-3 ${likelihoodColor(r.impact)}`}>{r.impact}</td>
                    <td className="px-4 py-3 text-slate-600">{r.responsibleOfficer}</td>
                    <td className="px-4 py-3"><ProcStatusBadge value={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ProcPagination
            page={data.number}
            totalPages={data.totalPages}
            totalElements={data.totalElements}
            onPage={setPage}
          />
        </>
      )}
    </div>
  );
}
